<template>
  <svg>
    <path :d="icon"></path>
  </svg>
</template>

<script>
export default {
  props: ["icon"]
};
</script>
